import { render, staticRenderFns } from "./Customizing.vue?vue&type=template&id=b11912e4"
import script from "./Customizing.vue?vue&type=script&lang=js"
export * from "./Customizing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports